/*
 * @Author: zhengxiaowen
 * @Date: 2018-10-10 20:45:58
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-24 14:36:17
 */
import {fetchTool} from '../index'
import api from './apiCommon'

let fetch = {}

fetch.bpmTaskService_findActiveTasks = (params) => fetchTool.post(api.bpmTaskService_findActiveTasks, params);

fetch.bpmCommunicateService_save = (params) => fetchTool.post(api.bpmCommunicateService_save, params);

export default fetch



// WEBPACK FOOTER //
// ./src/common/config/fetchDataCommon.js